import React, { useEffect, useState } from "react";
import customstyles from "./InstitutionsServices.module.scss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import CustomImage from "../CustomImage";
import Card from "react-bootstrap/Card";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import WebinarEvents from "../WebinarEvents";
import FeaturedBlogs from "../FeaturedBlogs";
import Recognition from "../Recognition";
import Testimonial from "../Testimonial";
import TopTieUpsOfKC from "../UniTieUp";
import fetchUtil from "../../utils/fetchUtil";
import KcNewLatestUpdates from "../kcNewlatestupdates";
import FaqComponent from "../PST/FrequentlyAskedQuestions";
import VideoTestimonials from "../PST/VideoTestimonials";
import { useRouter } from "next/router";
import { isFrappeOrJotFormClass } from "../../utils/helpers";
import Events from "./Events/Events";

const InstitutionsUniversitiesPage: React.FC = (props: any) => {
  const router = useRouter();

  const settingStuPer = {
    dotsClass: customstyles.sliderDots,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  const [topTieUps, setTopTieUps] = useState<any>({});
  useEffect(() => {
    fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/top-university-tie-ups`,
      "GET",
      {},
      "",
      false,
    ).then((res: any) => setTopTieUps(res));
  }, []);

  const renderCard = (solution: any) => {
    return (
      <Card className={customstyles.card}>
        <Card.Body className={customstyles.cardBody}>
          <div className={customstyles.imgDiv}>
            <CustomImage
              src={solution.imagePath}
              alt={solution.imageAltTag}
              width={70}
              height={70}
            />
          </div>
          <h6>{solution.title}</h6>
          <p>{solution.description}</p>
        </Card.Body>
      </Card>
    );
  };

  return (
    <div
      id="institutions-universities-page"
      className={customstyles.InstitutionServicesPage}
    >
      <div className={customstyles.studentServicesCurve}>
        <div className={customstyles.contentDiv}>
          <Container>
            <Row>
              <Col lg={6} md={6} xs={12}>
                <div className="d-block d-sm-none">
                  <Breadcrumb className={customstyles.mobileBreadCrum}>
                    <Breadcrumb.Item href="/" active>
                      Services
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="">For Institutes</Breadcrumb.Item>
                  </Breadcrumb>
                  <CustomImage
                    src={
                      props.pageData.mainImageUrl ||
                      "/images/institutions/institutions.svg"
                    }
                    alt={props.pageData.mainImageAltTag}
                    width={513}
                    height={424}
                  />
                </div>
                <div className={customstyles.servContent}>
                  <Breadcrumb className="d-none d-sm-block">
                    <Breadcrumb.Item href="/" active>
                      Services
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="">For Institutes</Breadcrumb.Item>
                  </Breadcrumb>
                  <h1>{props?.pageData?.title}</h1>
                  <p>{props?.pageData?.description}</p>
                  <a
                    className={`${customstyles.enquirebtn} ${`${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}`}`}
                    onClick={() => {
                      !props?.pageData?.meta?.jotforms[0]?.jotformid &&
                        router.push(props?.pageData?.externalLink);
                    }}
                  >
                    {" "}
                    {props?.pageData?.bannerBtn?.label || "Enquire Now"}
                  </a>
                </div>
              </Col>
              <Col lg={6} md={6} xs={12}>
                <div className="d-none d-sm-block text-center">
                  <CustomImage
                    src={
                      props.pageData.mainImageUrl ||
                      "/images/institutions/institutions.svg"
                    }
                    alt={props.pageData.mainImageAltTag}
                    width={513}
                    height={424}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <div className={customstyles.WhyKc}>
        <Container>
          <Row>
            <div className="mb-5 text-center">
              <h2>Why KC?</h2>
            </div>
          </Row>
          <Row>
            {props?.pageData?.whyKc?.length > 0 &&
              props?.pageData?.whyKc.map((kcBenefit: any) => {
                return (
                  <Col xl={4} md={4} xs={12}>
                    <div className="text-center mb-3">
                      <div className={customstyles.img}>
                        <CustomImage
                          src={kcBenefit?.imagePath}
                          alt={kcBenefit?.imageAltTag}
                          width={107}
                          height={76}
                        />
                      </div>
                      <h6>{kcBenefit?.title}</h6>
                      <p>{kcBenefit?.description}</p>
                      {/* <a className={styles.viewMore}>Know More</a> */}
                    </div>
                  </Col>
                );
              })}
          </Row>
        </Container>
      </div>

      <div
        id="high-performance-stud"
        className={customstyles.highPerformanceStu}
      >
        <Container>
          <Row>
            <Col xl={8} md={8} xs={12} className={customstyles.centered}>
              <div className="mb-5">
                <h2>
                  High Performance Student Recruitment Solutions through KC
                </h2>
              </div>
            </Col>
          </Row>
        </Container>

        {/* desktop view */}
        <div className="d-none d-sm-block">
          <Container>
            <Row>
              {props?.pageData?.studentRecruitmentSolutions?.length > 0 &&
                props?.pageData?.studentRecruitmentSolutions.map(
                  (solution: any, index: number) => {
                    return (
                      <Col
                        xl={6}
                        md={6}
                        xs={12}
                        className={
                          index + 1 ===
                          props?.pageData?.studentRecruitmentSolutions?.length
                            ? customstyles.centered
                            : ""
                        }
                      >
                        {renderCard(solution)}
                      </Col>
                    );
                  },
                )}
            </Row>
          </Container>
        </div>

        {/* mobile view */}
        <div className="d-block d-sm-none">
          <Container>
            <Slider {...settingStuPer} className={customstyles.slider}>
              {props?.pageData?.studentRecruitmentSolutions?.length > 0 &&
                props?.pageData?.studentRecruitmentSolutions.map(
                  (solution: any, index: number) => {
                    return <div>{renderCard(solution)}</div>;
                  },
                )}
            </Slider>
          </Container>
        </div>
      </div>

      <Events />

      <div id="wrappall-section" className={customstyles.wrappAllSection}>
        <div className={customstyles.getInTouch}>
          <Container>
            <Row>
              <Col>
                <div className={customstyles.expert}>
                  <div className={customstyles.centered}>
                    <h2>Get in touch with our expert team</h2>
                    <p>
                      Contact us today to discuss our customized student
                      recruitment solutions for your institution.
                    </p>
                    <a href="/contact-us">Contact Us</a>
                    <a
                      className={`${customstyles.enquirebtn} ${`${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}`}`}
                    >
                      Enquire Now
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className={customstyles.institutionWebinar}>
          <WebinarEvents headingLevel={2}/>
        </div>

        <div className={customstyles.institutionUnitie}>
          <TopTieUpsOfKC />
        </div>
      </div>

      <div className={customstyles.instiRecognitions}>
        <Recognition bgColor={"#B8AAEE"} />
      </div>

      <Testimonial
        title="Our institutes love us"
        bgColor="#FFFFFF"
        slug={`testimonials?type=institution&_limit=15&_sort=id:DESC`}
      />

      {props.pageData?.videoTestimonial && (
        <VideoTestimonials {...props.pageData.videoTestimonial} />
      )}

      <div className={customstyles.instituKcUpdates}>
        <KcNewLatestUpdates {...props} />
      </div>
      <div className={customstyles.institutionsBlogs}>
        <FeaturedBlogs />
      </div>
      {props.pageData?.faq && <FaqComponent {...props.pageData.faq} />}
    </div>
  );
};
export default InstitutionsUniversitiesPage;
